module.exports = __webpack_public_path__ + "static/img/Hessapp.3bafdef6.jpg";